var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"theme-content"},[_c('a-row',{attrs:{"gutter":[10, 1]}},[_c('a-col',{attrs:{"span":8}},[_c('ThemePlan')],1),_c('a-col',{attrs:{"span":8}},[_c('ThemeLog')],1),_c('a-col',{attrs:{"span":8}},[_c('ThemeDoc')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }